<template>
  <div v-if="!!orderForm.meta?.unboxingOnDelivery" class="vz-direction-calendar-time-unboxing">
    <div class="flex flex-align-items-start fs-16 text-medium mb-15">
      <vz-icon
        size=18
        class="mr-10"
        variant="lt-gray"
        url="/svg/package.svg"
      />
      Груз в защитной жесткой упаковке
    </div>
    <vz-radiogroup
      class="ml-25"
      v-model="unboxing"
      :items="unboxingItems"
      @change="onChangeUnboxing"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useOrderStore } from '~/stores/order';

const orderStore = useOrderStore()
const { orderForm } = storeToRefs(useOrderStore())

const unboxingItems = [
  {
    title: 'Разобрать на терминале',
    value: 'terminal',
  },
  {
    title: 'Привезти в упаковке и разобрать',
    value: 'address',
  },
  {
    title: 'Привезти в упаковке и не разбирать',
    value: 'without',
  },
]

const unboxing = computed({
  get(): string | null {
    const { terminal, address } = orderForm.value.meta?.unboxingOnDelivery
    return terminal && !address 
      ? 'terminal'
      : !terminal && address
        ? 'address'
        : 'without'
  },
  set(value: string): void {
    orderForm.value.meta.unboxingOnDelivery = value === 'terminal'
        ? { terminal: true, address: false }
        : value === 'address'
          ? { terminal: false, address: true }
          : { terminal: false, address: false }
  
  }
})

function onChangeUnboxing() {
  orderStore.getOrderPriceAction()
}
</script>

<style lang="scss" scoped>
.vz-direction-calendar-time-unboxing {
  border: 1px solid $border-gray;
  padding: 20px 20px 15px 20px;
  border-radius: 12px;

  :deep(.vz-radiogroup-item) {
    margin-bottom: 5px;
    align-items: flex-start;

    .vz-radiogroup-item-title {
      margin-left: 7px;
    }

    .vz-radiogroup-item-radio {
      margin-top: 1px;

      &::after {
        font-size: 17px;
        line-height: 17px;
      }
    }
  }
}
</style>
